import axios from 'axios';
import moment from 'moment';
import type {
  AppointmentsMyBusinessDTOV2,
  BuildJsonType,
  FetchAppointmentsOptions,
} from '@bb/domain/dist/types';

const appointments = async (options: FetchAppointmentsOptions) => {
  const params: BuildJsonType<FetchAppointmentsOptions> = {
    ...options,
    dateFrom: options.dateFrom
      ? moment(options.dateFrom).startOf('day').toISOString()
      : undefined,
    dateTo: options.dateTo
      ? moment(options.dateTo).endOf('day').toISOString()
      : undefined,
  };

  const { data } = await axios.get<AppointmentsMyBusinessDTOV2>(
    '/showing_calendar/appointments',
    { params },
  );

  return data;
};
export default appointments;
